export const blockIconsCommunicationHourglassBottom = (
	<span className='material-symbols-outlined'>hourglass_bottom</span>
);
